"use client";

import { useEffect } from "react";
import { usePathname, useRouter } from "next/navigation";

export default function ScrollToTop({ dependencyArr = [] }) {
  const pathname = usePathname();
  const router = useRouter();

  useEffect(() => {
    const el = document.getElementById("top-banner-main");
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      // Fallback to top if element not found
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [pathname, router, ...dependencyArr]);

  return null;
}
